export default __webpack_public_path__ + "media/images/pencil_disabled-eee88c087e77301f9c7a8eb279fa93ce.png";